// extracted by mini-css-extract-plugin
module.exports = {"root":"Notifications_root__3h6ly"};